import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Input } from 'reactstrap';
import { useIntl } from 'react-intl';

const AdminUsersListHeader = ({
  orderBy,
  order,
  selectedUsers,
  users,
  handleSelectUser,
  handleChangeOrder,
}) => {
  const intl = useIntl();

  const changeOrder = (e, field) => {
    e.preventDefault();
    handleChangeOrder(field, order === 'asc' ? 'desc' : 'asc');
  };

  return (
    <tr>
      <th className="selector">
        <Input
          type="checkbox"
          name="selected-user"
          value="all"
          checked={selectedUsers.length === users.length}
          onChange={handleSelectUser}
          className={classnames({ hidden: users.length === 0 })}
        />
      </th>
      <th className={`th-sortable${orderBy === 'name' ? ' active' : ''}`}>
        <a href="#sort" onClick={(e) => { changeOrder(e, 'name'); }}>
          {intl.formatMessage({ defaultMessage: 'Name' })}
          {' '}
          {orderBy === 'name' && (
            <i className={`fas fa-long-arrow-${order === 'asc' ? 'down' : 'up'}`} />
          )}
        </a>
      </th>
      <th className={`th-sortable${orderBy === 'email' ? ' active' : ''}`}>
        <a href="#sort" onClick={(e) => { changeOrder(e, 'email'); }}>
          {intl.formatMessage({ defaultMessage: 'Email' })}
          {' '}
          {orderBy === 'email' && (
            <i className={`fas fa-long-arrow-${order === 'asc' ? 'down' : 'up'}`} />
          )}
        </a>
      </th>
      <th className={`th-sortable${orderBy === 'role' ? ' active' : ''}`}>
        <a href="#sort" onClick={(e) => { changeOrder(e, 'role'); }}>
          {intl.formatMessage({ defaultMessage: 'Role' })}
          {' '}
          {orderBy === 'role' && (
            <i className={`fas fa-long-arrow-${order === 'asc' ? 'down' : 'up'}`} />
          )}
        </a>
      </th>
      <th className={`th-sortable${orderBy === 'created_at' ? ' active' : ''}`}>
        <a href="#sort" onClick={(e) => { changeOrder(e, 'created_at'); }}>
          {intl.formatMessage({ defaultMessage: 'Registered' })}
          {' '}
          {orderBy === 'created_at' && (
            <i className={`fas fa-long-arrow-${order === 'asc' ? 'down' : 'up'}`} />
          )}
        </a>
      </th>
      <th>
        {' '}
      </th>
    </tr>
  );
};

AdminUsersListHeader.propTypes = {
  orderBy: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  users: PropTypes.array.isRequired,
  selectedUsers: PropTypes.array.isRequired,
  handleSelectUser: PropTypes.func.isRequired,
  handleChangeOrder: PropTypes.func.isRequired,
};

export default AdminUsersListHeader;
